/**
 * Interface for the 'ShipmentTimelineEvents' data
 */
import {Moment} from 'moment';
import { IconName } from '@fortawesome/pro-light-svg-icons';

export interface ShipmentTimelineEvent {
    _id: string; // Primary ID
    id: string; // Primary ID
    key: string;
    sort?: number;
    icon: IconName;
    expected_timestamp?: string | Date | Moment;
    expected_label: string;
    expected_timestamp_local?: string | Date | Moment;
    expected_tzn: string;
    expected_timezone: string;
    expected_timezone_code: string;
    actual_timestamp?: string | Date | Moment;
    actual_label: string;
    actual_timestamp_local?: string | Date | Moment;
    actual_tzn: string;
    actual_timezone: string;
    actual_timezone_code: string;
    notes?: string;
    user_id?: string | number;
    location?: ShipmentTimelineEventLocation;
    reference?: string;
    created_at?: string | Date | Moment;
    updated_at?: string | Date | Moment;
    shipment_id?: string;
    expected_location_source?: string;
    expected_timestamp_source?: string;
    expected_timestamp_history?: {
        expected_timestamp: Date;
        updated_at: Date;
    }[];
    fromHubUser: boolean;
}

export interface ShipmentTimelineEventLocation {
    locode: string;
    name: string;
    label: string;
    display_name: string;
    country_code: string;
    country_name: string;
    position?: [number, number];
    speed?: number;
    heading?: number;
    last_update?: string | Date | Moment;
}
